import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Accordion, AccordionSummary, AccordionDetails, Typography, CircularProgress } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './CSS/FAQ.css';
import { API_URL } from '../apiConfig';

const FAQ = ({ darkMode }) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/faqs`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('accessToken')}` }
    })
    .then(response => {
      setFaqs(response.data);
      setLoading(false);
    })
    .catch(err => {
      console.error('Error fetching FAQs:', err);
      setError('Failed to fetch FAQs. Please try again later.');
      setLoading(false);
    });
  }, []);

  const createMarkup = (html) => {
    return { __html: html };
  };

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <div className={`faq-container ${darkMode ? 'dark' : ''}`}>
      <Typography variant="h4" gutterBottom>Frequently Asked Questions</Typography>
      {faqs.map((faq) => (
        <Accordion key={faq.id}>
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon />} 
            aria-controls={`faq-content-${faq.id}`} 
            id={`faq-header-${faq.id}`}
          >
            <div dangerouslySetInnerHTML={createMarkup(faq.question)} />
          </AccordionSummary>
          <AccordionDetails>
            <div dangerouslySetInnerHTML={createMarkup(faq.answer)} />
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default FAQ;